interface ComplexContentBaseFields {
  readonly type: ComplexContentType
}

interface ComplexContentText {
  readonly type: ComplexContentType.Text
  readonly text: string
}
interface ComplexContentImage {
  readonly type: ComplexContentType.Image
  readonly url?: string
  readonly subtitle?: string
}
interface ComplexContentVideo {
  readonly type: ComplexContentType.Video
  readonly url: string
  readonly subtitle?: string
}
interface ComplexContentIFrame {
  readonly type: ComplexContentType.IFrame
  readonly iframe: string
  readonly subtitle?: string
}

export enum ComplexContentType {
  Image = 'image',
  Video = 'video',
  IFrame = 'iframe',
  Text = 'text'
}

export type ComplexContent = ComplexContentBaseFields &
  (
    | ComplexContentText
    | ComplexContentImage
    | ComplexContentVideo
    | ComplexContentIFrame
  )
